import React, { Component } from 'react';
import Footer from '../../parts/Footer';
import { Button } from 'react-bootstrap';
import templatePersegi from '../../assets/images/template persegi.png';
import Card from '../../parts/Card Merch/index';
import DataCard from '../../json/dataCardMerch.json';
import CardCategory from '../../parts/Card Category/index';
import DataCardCategory from '../../json/dataCardCategory.json';
import './MerchLandingPage.scss';

class MerchLandingPage extends Component{
    render() {
        return (
            <div>
                <div class="jumbotron jumbotron-fluid p-5">
                    <div class="row">
                        <h1 class="display-4 col-lg-6 title">Be part of Impulse with these schwag</h1>
                        <div class="bg-secondary row rounded description">
                            <div class="col-lg-6 p-4">
                                <p class="lead">
                                    This is a modified jumbotron that occupies the entire horizontal space of its parent.
                                    This is a modified jumbotron that occupies the entire horizontal space of its parent.
                                    This is a modified jumbotron that occupies the entire horizontal space of its parent.<br/>
                                </p>
                                <Button className="shadow btn btn-primary button w-50">Shop Now!</Button>
                            </div>
                            <div class="float col-sm-6 col-md-3 offset-lg-2 offset-md-3 offset-sm-2 p-0 bg-danger">
                                <img 
                                    src={templatePersegi}
                                    class="rounded shadow w-100"
                                    alt="shirt"
                                />
                                <img 
                                    src={templatePersegi}
                                    class="float2 rounded shadow w-100 position-absolute"
                                    alt="shirt"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <h2 class="trending">Trending Product</h2>
                <div class="container-fluid">
                    <div class="scrolling-wrapper row flex-row flex-nowrap my-3 py-4">
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                    </div>
                </div>

                <h2>Categories</h2>
                <div class="container row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 my-5 mx-auto">
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                </div>

                <Footer />
            </div>
        )
    }
}

export default MerchLandingPage;